export class MediaUploadClientError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'MediaUploadClientError';
  }
}
